import { memo } from 'react';
import { useTranslation } from 'react-i18next';

export const SpanNothing = memo(() => {
  const { t } = useTranslation();
  return <span className="text-foreground/70 font-normal text-sm text-center">{t('nothing-yet')}</span>;
});
